import React from 'react';
import { ModalButton } from '../../Button';
import { StyledTextEditorFooter } from '../../Styled';
import { COLORS } from '../../../constants';

interface ITextEditorFooter {
  mainColor: string;
  onSave: () => void;
}

export const TextEditorFooter: React.FC<ITextEditorFooter> = React.memo(props => {
  const { mainColor, onSave } = props;

  return (
    <StyledTextEditorFooter>
      <ModalButton color={COLORS.white} bGColor={mainColor} text="Save & Exit" margin="0px" onButtonClick={onSave} />
    </StyledTextEditorFooter>
  );
});
